import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M2 28V0H0v29a1 1 0 001 1h4v2h2v-2h3v2h2v-2h3v2h2v-2h3v2h2v-2h3v2h2v-2h5v-2H2z"></path>
          <path d="M27 7.001c-1.654 0-3 1.346-3 3 0 .461.113.894.3 1.285l-4.016 4.016a2.964 2.964 0 00-1.285-.3c-.462 0-.894.113-1.285.3L16.7 14.286c.187-.391.3-.823.3-1.285 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 .461.113.894.3 1.285l-2.016 2.016a2.964 2.964 0 00-1.285-.3c-1.654 0-3 1.346-3 3A3.004 3.004 0 008 22.001c1.654 0 3-1.346 3-3a2.97 2.97 0 00-.301-1.286l2.015-2.015a2.97 2.97 0 001.286.301 2.97 2.97 0 001.286-.301l1.015 1.015A2.97 2.97 0 0016 18.001c0 1.654 1.346 3 3 3s3-1.346 3-3a2.97 2.97 0 00-.301-1.286l4.015-4.015a2.97 2.97 0 001.286.301c1.654 0 3-1.346 3-3s-1.346-3-3-3zm-19 13c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zm6-6c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zm5 5c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zm8-8c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1z"></path>
        </svg>
    );
}